import * as profile from "./profile";
import * as wabas from "../waba/waba";
import * as partners from "../partners/partners";
import * as clients from "../clients/clients";
import * as projects from "../projects/projects";
import * as wabaAccounts from "../wabaAccount/wabaAccount";
import * as channels from "../channels/channels";
import * as partnerChannels from "../partnerChannels/partnerChannels";
import * as users from "../user/hubUser";
import * as apiKeys from "../apiKeys/apiKeys";
import * as comments from "../comments/comments";
import * as accounting from "../accounting/accounting";
import * as paymentConnections from "../paymentConnections/paymentConnections";
import * as publicRequests from "../publicRequests/public";
import * as statusPage from "../statusPage/statusPage";
import * as notifications from "../notifications/notifications";
import * as sessions from "../sessions/session";
import * as tos from "../tos/tos";
import * as subscriptions from "../subscriptions/subscriptions";
import * as authX from "../authX/authX";
import * as notificationType from "../notificationType/notificationType";
import { postCancelationReason } from "../googleScripts";
import * as sandbox from "../sandbox/sandbox";
import { createAuditLog } from "@/api/auditLogs/auditLogs";
import * as messaging from "../messaging/messaging";
export default {
    profile: {
        get: profile.getAdminProfile,
        patch: profile.updateProfile,
        checkEmailVerification: profile.getEmailVerification,
        requestEmailVerification: profile.requestVerificationEmail,
    },
    apiKeys: {
        get: {
            list: apiKeys.getApiKeys,
        },
        delete: {
            all: apiKeys.deleteApiKeys,
        },
        post: apiKeys.createApiKey,
    },
    wabas: {
        get: {
            list: wabas.getWabas,
            single: channels.getIntegration,
        },
        post: wabas.setupWaba,
        registration: {
            post: {
                trigger: wabas.wabaTriggerRegistration,
                triggerWithAppId: wabas.wabaTriggerRegistrationWithAppId,
                finish: wabas.wabaFinishRegistration,
            },
        },
    },
    partners: {
        get: {
            list: partners.getPartners,
            single: partners.getPartner,
            check: partners.getPartnerPaymentInfo,
            validatePartnerExists: partners.validatePartnerExists,
            paymentPlan: partners.getPartnerPaymentPlan,
            paymentMethods: partners.getPartnerPaymentMethods,
            billingData: partners.getPartnerBillingData,
            invoices: partners.getPartnerInvoices,
            partnerInvoiceAsPDF: partners.getPartnerInvoiceAsPDF,
            unpaidInvoiceLink: partners.getPartnerUnpaidInvoiceLink,
            paymentSession: partners.getPartnerPaymentSession,
            balanceSettings: partners.getPartnerBalanceSettings,
            balance: partners.getPartnerBalance,
            partnerTransactions: partners.getPartnerTransactions,
            bundles: partners.getPartnerBundles,
            catalogPlans: partners.getPartnerCatalogPlans,
        },
        updateBalanceSettings: partners.updatePartnerBalanceSettings,
        updateBillingData: partners.updatePartnerBillingData,
        updateBillingDataWithTerms: partners.updatePartnerBillingDataWithTerms,
        post: {
            addPartner: partners.addPartner,
            billingTerms: partners.billingTerms,
            revokeCancellation: partners.revokeCancellation,
            createClientAccount: partners.createPartnerClientAccount,
            pbsInvoiceManualNew: partners.createPbsManualInvoice,
            paymentMethods: {
                reorder: partners.reorderPartnerPaymentMethod,
                reorderAll: partners.reorderAllPartnerPaymentMethods,
                deactivate: partners.deactivatePartnerPaymentMethod,
            },
        },
        patch: {
            updatePaymentPlan: partners.updatePartnerPaymentPlan,
            editPartner: partners.editPartner,
            editAccountSharing: partners.editAccountSettings,
            editLocalizationRegion: partners.editLocalizationRegion,
            editAuthSettings: partners.editAuthSettings,
            editMarketingTemplatesRouting: partners.editMarketingTemplatesRouting,
        },
        delete: {
            cancelSubscription: partners.cancelSubscription,
        },
        sendWebhookEvent: partners.sendWebhookEvent,
        fbAccountInfo: {
            get: partners.getFacebookBusinessAccountInfo,
        },
        filterOptions: {
            get: partners.getPartnerFilterOptions,
        },
        publicFilterOptions: {
            get: partners.getPublicFilterOptions,
        },
        partnerUser: {
            post: partners.addPartnerUser,
        },
        activations: {
            triggerActivation: partners.triggerActivation,
            approve: partners.approve,
        },
        apiKey: {
            post: partners.addApiKey,
        },
        addLogo: partners.addLogo,
        partnerChangeRequest: {
            get: {
                list: partners.getPartnerChangeRequests,
                single: partners.getSinglePartnerChangeRequest,
            },
            post: {
                approve: partners.approvePartnerChangeRequest,
                reject: partners.rejectPartnerChangeRequest,
            },
        },
        v2PartnerChangeRequest: {
            get: partners.getV2PartnerChangeRequest,
            post: { approve: partners.approveV2PartnerChangeRequest },
        },
        vatInfo: partners.updateBusinessVAT,
    },
    users: {
        checkExistence: users.checkUser,
        get: {
            list: users.getUsers,
            single: users.getUser,
        },
        post: users.addUser,
        patch: users.updateUser,
        delete: users.deleteUser,
    },
    clients: {
        get: {
            list: clients.getClientsList,
            single: clients.getClient,
            csvData: clients.getClientData,
            billingData: clients.getClientBillingData,
        },
        post: clients.createClient,
        generateClientDataToEmail: clients.generateClientDataToEmail,
        patch: clients.updateClient,
        payment: {
            get: clients.getClientPaymentToken,
            paymentSession: clients.getClientPaymentSession,
            check: clients.checkPayment,
            additionalDetails: clients.submitAdditionalDetails,
            paymentMethods: clients.getClientPaymentMethods,
        },
        fbCallback: clients.postFbCallbackToken,
        partnerChangeRequest: {
            create: clients.createPartnerChangeRequest,
            get: {
                list: clients.getPartnerChangeRequests,
                preview: clients.getPartnerChangeRequestPreview,
            },
            post: {
                cancel: clients.cancelPartnerChangeRequest,
            },
        },
        vatInfo: clients.updateBusinessVAT,
        updateChatSupport: clients.updateChatSupport,
    },
    projects: {
        get: {
            list: projects.getProjectsList,
            single: projects.getProject,
            apiKey: projects.getApiKey,
        },
        post: projects.addProject,
        patch: projects.editProject,
    },
    wabaAccounts: {
        get: {
            list: wabaAccounts.getWabaAccountsList,
            single: wabaAccounts.getWabaAccount,
        },
        post: wabaAccounts.addWabaAccount,
        patch: wabaAccounts.editWabaAccount,
        delete: wabaAccounts.deleteWabaAccount,
        activations: {
            post: {
                submit: wabaAccounts.submitWaba,
                updateTemplateNamespace: wabaAccounts.updateTemplateNamespace,
                synchronizeStatus: wabaAccounts.synchronizeStatus,
                messageOnBehalfReminder: wabaAccounts.messageOnBehalfReminder,
                businessVerificationReminder: wabaAccounts.businessVerificationReminder,
            },
        },
        payment: {
            post: wabaAccounts.paymentWaba,
        },
        synchronizeSharedWaba: {
            post: wabaAccounts.synchronizeSharedWaba,
        },
    },
    paymentConnection: {
        approve: paymentConnections.approveMessageForwarding,
    },
    channels: {
        get: {
            list: channels.getChannelsList,
            single: channels.getChannel,
            profile: channels.getProfile,
            commerceSettings: channels.getWhatsAppCommerceSettings,
        },
        uploadProfilePhoto: channels.uploadProfilePhoto,
        post: channels.addChannel,
        patch: {
            editChannel: channels.editChannel,
            editWaba: channels.editWaba,
            adminEditChannel: channels.adminEditChannel,
            editCommmerceSettings: channels.updateWhatsAppCommerceSettings,
        },
        delete: channels.deleteChannel,
        consentsClient: {
            post: channels.updateChannelConsents,
        },
        consentsClientData: {
            get: channels.getChannelConsentsClientData,
            post: channels.updateChannelConsentsClientData,
        },
        consents: {
            patch: channels.updateConsents,
            delete: channels.deleteConsents,
        },
        number: {
            post: {
                addNumberChannel: channels.addNumberChannel,
                deleteNumber: channels.deleteNumber,
                revokeNumberDeletion: channels.revokeNumberDeletion,
            },
        },
        activations: {
            post: {
                submitChannel: channels.submitChannel,
                updateChannelStatus: channels.updateStatusChannel,
                updatePhoneName: channels.updatePhoneName,
                updateDeclinedPhoneName: channels.updateDeclinedPhoneName,
                channelsWabaRegistrationReminder: channels.channelsWabaRegistration,
                setAvailability: channels.setChannelAvailability,
                setVerified: channels.setChannelVerified,
                updateBillingFinish: channels.updateBillingFinish,
                updateBillingStart: channels.updateBillingStart,
                grantPermissions: channels.grantPermissions,
            },
            get: {
                getPermissionsList: channels.getPermissionsList,
            },
        },
        migration: {
            submitMigration: channels.submitMigration,
            requestVerification: channels.requestVerification,
            verifyMigration: channels.verifyMigration,
            migrateChannel: channels.migrateChannel,
            migrateToCloudAPI: channels.migrateChannelToCloudAPI,
            migrateToOnPremiseAPI: channels.migrateChannelToOnPremiseAPI,
            requestCode: channels.requestCode,
            verifyCode: channels.verifyCode,
        },
        inbox: {
            changeInboxSettings: channels.changeInboxSettings,
        },
        getCurrentPrice: channels.getCurrentPrice,
        setPricingTier: channels.setPricingTier,
        setWebhook: channels.setChannelWebhook,
    },
    partnerChannelsV2: {
        trigger: partnerChannels.getPartnerChannelsV2,
    },
    partnerChannels: {
        get: {
            list: partnerChannels.getPartnerChannels,
            single: partnerChannels.getPartnerChannel,
            webhookUrl: partnerChannels.getChannelWebhookUrl,
        },
        post: {
            fromPipe: partnerChannels.addPartnerChannelFromPipe,
            fromSubmit: partnerChannels.addPartnerChannelFromSubmitWaba,
            fromMigrationForm: partnerChannels.addPartnerChannelFromMigrateWaba,
            webhookUrl: partnerChannels.updateChannelWebhookUrl,
        },
    },
    comments: {
        get: {
            list: comments.getComments,
            single: comments.getComment,
        },
        post: comments.addComment,
    },
    accounting: {
        triggerInvoicesCreation: accounting.triggerInvoicesCreation,
        triggerTemplateInvoicesCreation: accounting.triggerTemplateInvoicesCreation,
        triggerTemplateReportCreation: accounting.triggerTemplateReportCreation,
        triggerCbpReportCreation: accounting.triggerCbpReportCreation,
        triggerCbpReportDailyCreation: accounting.triggerCbpReportDailyCreation,
        triggerCbpInvoicesCreation: accounting.triggerCbpInvoicesCreation,
        stripe: {
            createPortal: accounting.stripeCreatePortal,
            createPortalPartner: accounting.stripeCreatePortalPartner,
        },
        get: {
            autoRecharge: accounting.getAutoRecharge,
            funds: accounting.getClientBalance,
            partnerClientsFunds: accounting.getPartnerClientsBalance,
            channelBalance: accounting.getChannelBalance,
            channelBalanceList: accounting.getChannelBalanceList,
            channelAutoRecharge: accounting.getChannelAutoRecharge,
            channelAutoRechargeList: accounting.getChannelAutoRechargeList,
            channelsFilteredBalance: accounting.getFilteredChannelsBalance,
            checkPaymentsInfo: accounting.checkPaymentsInfo,
            addEbanxFunds: accounting.getPartnerEbanxAddFunds,
            ebanxPaymentMethod: accounting.getPartnerEbanxPaymentMethod,
            bankTransferInstructions: partners.getBankTransferInstructions,
        },
        post: {
            addFunds: accounting.addFunds,
            addPartnerFunds: accounting.addPartnerFunds,
            calculateCost: accounting.calculateCost,
            autoRecharge: accounting.setAutoRecharge,
            addChannelFunds: accounting.addChannelFunds,
            requestRefund: accounting.requestRefund,
            channelAutoRecharge: accounting.setChannelAutoRecharge,
        },
    },
    publicRequests: {
        outageEvent: publicRequests.outageEvent,
        verifyCaptcha: publicRequests.verifyCaptcha,
        triggerEmailVerification: publicRequests.triggerEmailVerification,
        verifyEmail: publicRequests.verifyEmail,
        checkPartner: publicRequests.checkPartner,
        checkStatus: publicRequests.checkStatus,
    },
    statusPage: {
        getOverallStatus: statusPage.getOverallStatus,
        addSubscriberMainStatusPage: statusPage.addSubscriberMainStatusPage,
    },
    notifications: {
        get: {
            list: notifications.getNotifications,
            getAllNotifications: notifications.getAllNotifications,
        },
        post: {
            markNotificationAsRead: notifications.markNotificationAsRead,
        },
    },
    omni: {
        omniSession: sessions.getOmniSession,
    },
    synchronizeSharedWaba: {
        post: wabaAccounts.synchronizeSharedWaba,
    },
    postCancelationReason: postCancelationReason,
    tos: {
        get: {
            getAcceptance: tos.getAcceptance,
            getLatestTosVersion: tos.getLatestTosVersion,
            getTosDocByRevision: tos.getTosDocByRevision,
        },
        post: {
            acceptTos: tos.acceptTos,
        },
    },
    subscriptions: {
        get: {
            list: subscriptions.getSubscriptionsList,
        },
    },
    authX: {
        apiKey: {
            get: {
                list: authX.getApiKeys,
            },
            post: {
                generate: authX.generateApiKey,
            },
            delete: {
                deleteApiKey: authX.deleteApiKey,
            },
        },
    },
    notificationType: {
        get: {
            getUserConfiguration: notificationType.getUserConfiguration,
            getNotificationTypes: notificationType.getNotificationTypes,
        },
        post: {
            createOrUpdateUserConfiguration: notificationType.createOrUpdateUserConfiguration,
        },
    },
    auditLogs: {
        post: createAuditLog,
    },
    sandbox: {
        get: {
            getSandbox: sandbox.getSandbox,
            getWebhookUrl: sandbox.getWebhookUrl,
            eventsList: sandbox.getWebhookEvents,
        },
        post: {
            initiatePhoneVerification: sandbox.initiatePhoneVerification,
            sendMessage: sandbox.sendMessage,
            configureWebhookUrl: sandbox.updateWebhookUrl,
        },
        delete: sandbox.deleteSandbox,
    },
    messaging: {
        get: {
            partnerSafeMode: messaging.getPartnerSafeMode,
            partnerWabaStates: messaging.getPartnerWabaStates,
            allPartnerWabaStates: messaging.getAllPartnerWabaStates,
        },
        post: {
            partnerSafeMode: messaging.setPartnerSafeMode,
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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